import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const StyledTableHeader = styled(Grid)`
  /* background-color: ${({ theme }) => theme.palette.secondary.main}; */
  align-items: center;
  margin-bottom: 20px;
  .Mui-focused {
    svg {
      transition: 0.2s;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
  .MuiOutlinedInput-root {
    border-radius: 80px !important;
  }
  .MuiOutlinedInput-input {
    padding: 13.5px 14px;
  }
`;
